import {
  Avatar,
  Box,
  Button,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import logo from "assets/icons/referee-main.svg";
import { Field, Form, Formik } from "formik";
import { setForgotPasswordEmail } from "lib/features/auth/authSlice";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import authServices, { ForgotPaswordDto } from "services/auth-service";
import { authStyles } from "styles/common/auth.styles";
import * as Yup from "yup";

const forgotPasswordValidation = Yup.object({
  email: Yup.string()
    .email("Invalid email address")
    .required("Email is required"),
});

const ForgotPassword = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues: ForgotPaswordDto = {
    email: "",
  };
  const [loader, setLoader] = useState<boolean>(false);
  const [error, setError] = useState<string | undefined>(undefined);

  const onSubmit = async (values: ForgotPaswordDto) => {
    try {
      setLoader(true);
      const result = await authServices.forgotPassword(values);
      if (result.status === 201) {
        dispatch(setForgotPasswordEmail(values.email));
        navigate("/verify-otp");
      }
    } catch (error: any) {
      setError(error?.response?.data?.message);
      setTimeout(() => {
        setError(undefined);
      }, 3000);
    } finally {
      setLoader(false);
    }
  };

  return (
    <Box width="100%" position="relative">
      {/* Form */}
      <Box sx={authStyles.authContainer(theme)}>
        <Box sx={authStyles.avatarContainer}>
          <Avatar sx={authStyles.avatar}>
            <img src={logo} alt="logo" style={authStyles.avatarImage} />
          </Avatar>
        </Box>

        <Formik
          initialValues={initialValues}
          validationSchema={forgotPasswordValidation}
          onSubmit={(values) => onSubmit(values)}
        >
          {({ values, errors, touched, handleChange }) => (
            <Form>
              <Box sx={authStyles.textContainer}>
                <Typography variant="h6" textAlign={"center"}>
                  Forgot Your Password?
                </Typography>
                <Typography variant="body2" textAlign={"center"}>
                  Please enter your email address below to recieve a
                  verification code
                </Typography>
              </Box>

              {/* Email */}
              <Box>
                <Field
                  as={TextField}
                  name="email"
                  label="Email Address"
                  fullWidth
                  onChange={handleChange}
                  value={values.email}
                  error={touched.email && Boolean(errors.email)}
                />
                {errors.email && touched.email && (
                  <Typography color="red" fontSize="12px">
                    {errors.email}
                  </Typography>
                )}
              </Box>

              {error && (
                <Typography sx={authStyles.errorText}>{error}</Typography>
              )}

              <Button
                type="submit"
                variant="contained"
                sx={authStyles.actionBtn}
                disabled={loader}
              >
                Send Email
              </Button>
            </Form>
          )}
        </Formik>
      </Box>
    </Box>
  );
};

export default ForgotPassword;
